module.exports = __webpack_public_path__ + "img/img_student5.3c187397.png";